import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { VehicleType } from '@/types/vehicle-type'

export function updateVehicleType(
  body: VehicleType
): Promise<AxiosResponse<VehicleType>> {
  return instance.put(`/vehicle-type/${body.uuid}`, body)
}
